import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { uploadImagecertifates } from "../../../Redux/Actions/Action";
import axios from "axios";
import toast from "react-hot-toast";
import { IoIosCloseCircle } from "react-icons/io";
import imgforbanner from "../../../assets/images/product/imgforbanner.png";
import { useNavigate, useParams } from "react-router-dom"; 

function AddAppView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [imageFor, setImageFor] = useState("");
  const [bannerType, setBannerType] = useState("forMobile");
  const [loading, setLoading] = useState(false);
  const [imageId, setImageId] = useState(null); 

  // ✅ Prefill existing banner if id exists
  useEffect(() => {
    if (!id) return;

    const fetchBanner = async () => {
      try {
        const token = localStorage.getItem("vedhvidhi-admin-token");
        const response = await axios.get(
          `${process.env.REACT_APP_BASEURL}/admin/banner/hero/${bannerType}/${id}`,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          const banner = response.data.data;
          setTitle(banner.bannerTitle || "");
          setImage(banner.imageUrl || null);
          setImageFor(banner.imageFor || "");
          setImageId(banner._id); // ✅ store imageId for PATCH
        }
      } catch (error) {
        console.error("Error fetching banner:", error);
        toast.error("Failed to fetch banner details");
      }
    };

    fetchBanner();
  }, [id, bannerType]);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    try {
      const uploadedImageUrl = await dispatch(uploadImagecertifates(file));
      setImage(uploadedImageUrl);
      toast.success("Image uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload image");
    }
    setLoading(false);
  };

  const handleRemoveImage = () => setImage(null);

  const handleSave = async () => {
    if (!title || !image || !imageFor) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");

      if (id) {
        // ✅ PATCH (Update existing banner)
        const payload = {
          bannerType,
          imageId, // required for PATCH
          bannerTitle: title,
          imageFor,
          imageUrl: image,
        };

        const response = await axios.patch(
          `${process.env.REACT_APP_BASEURL}/admin/banner/hero`,
          payload,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          toast.success("Banner updated successfully!");
          navigate("/top-banners");
        } else {
          toast.error("Failed to update banner");
        }
      } else {
        // ✅ POST (Add new banner)
        const payload = {
          bannerType,
          heroBanners: [
            {
              bannerTitle: title,
              imageFor,
              imageUrl: image,
            },
          ],
        };

        const response = await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/banner`,
          payload,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          toast.success("App banner added successfully!");
          setTitle("");
          setImage(null);
          setImageFor("");
          navigate("/top-banners");
        } else {
          toast.error("Failed to add banner");
        }
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error);
      toast.error(error.response?.data?.message || "Error saving banner");
    }
  };

  return (
   <>
        <button
        onClick={() => window.history.back()}
        style={{
          marginBottom: "10px",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          fontFamily: "monospace",
          fontSize: "18px",
          color: "#007bff",
          display: "flex",
          alignItems: "center",
          position: "relative",
          padding: "10px 20px",
        }}
      >
        <span style={{ marginRight: "8px" }}>&lt;</span>
        <span style={{ position: "relative", display: "inline-block" }}>
          Back
          <span
            style={{
              content: "''",
              position: "absolute",
              left: 0,
              bottom: -2,
              width: "100%",
              height: "1px",
              borderBottom: "2px solid #007bff",
            }}
          ></span>
        </span>
      </button>
    <div className="card">
      <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
        <h6 className="mb-0 fw-bold">{id ? "Edit App Banner" : "Add App Banner"}</h6>
      </div>

      <div className="card-body">
        <form>
          <div className="mb-3">
            <label className="form-label fw-bold">Banner Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter banner title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Banner Image</label>
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.webp"
              className="form-control"
              onChange={handleImageUpload}
            />
            <div className="mt-3">
              {image ? (
                <div className="position-relative d-inline-block">
                  <img
                    src={image}
                    alt="uploaded"
                    style={{
                      width: "200px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                    }}
                  />
                  <button
                    type="button"
                    className="btn btn-sm bg-transparent border-0 position-absolute top-0 end-0"
                    onClick={handleRemoveImage}
                  >
                    <IoIosCloseCircle size={26} color="#727070" />
                  </button>
                </div>
              ) : (
                <img
                  src={imgforbanner}
                  alt="default"
                  style={{ width: "200px", height: "100px", objectFit: "cover" }}
                />
              )}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Banner For</label>
            <select
              className="form-select"
              value={imageFor}
              onChange={(e) => setImageFor(e.target.value)}
            >
              <option value="">-- Select Banner For --</option>
              <option value="wallet">Wallet</option>
              <option value="consultation">Consultation</option>
              <option value="appointment">Appointment</option>
              <option value="education">Education</option>
            </select>
          </div>

          <div className="mt-4">
            <button
              type="button"
              className="btn btn-primary px-5"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? "Saving..." : id ? "UPDATE" : "SAVE"}
            </button>
          </div>
        </form>
      </div>
    </div>
   </>
  );
}

export default AddAppView;
